import { API_BASE_URL } from '../config';

class CommunicationHubService {
  getAuthHeaders() {
    const token = localStorage.getItem('token');
    return {
      'Content-Type': 'application/json',
      'Authorization': token ? `Bearer ${token}` : ''
    };
  }

  async getTemplates(category = 'ALL') {
    const url = new URL(`${API_BASE_URL}/api/communication/templates`);
    if (category && category !== 'ALL') url.searchParams.append('category', category);

    const res = await fetch(url, { headers: this.getAuthHeaders() });
    return res.json();
  }

  async saveTemplate(template) {
    const res = await fetch(`${API_BASE_URL}/api/communication/templates`, {
      method: 'POST',
      headers: this.getAuthHeaders(),
      body: JSON.stringify(template)
    });
    return res.json();
  }

  async getRules(category = 'ALL') {
    const url = new URL(`${API_BASE_URL}/api/communication/rules`);
    if (category && category !== 'ALL') url.searchParams.append('category', category);

    const res = await fetch(url, { headers: this.getAuthHeaders() });
    return res.json();
  }

  async saveRule(rule) {
    const res = await fetch(`${API_BASE_URL}/api/communication/rules`, {
      method: 'POST',
      headers: this.getAuthHeaders(),
      body: JSON.stringify(rule)
    });
    return res.json();
  }

  async sendBroadcast(payload) {
    const res = await fetch(`${API_BASE_URL}/api/communication/broadcast`, {
      method: 'POST',
      headers: this.getAuthHeaders(),
      body: JSON.stringify(payload)
    });
    return res.json();
  }

  async getHistory(page = 0, size = 30) {
    const res = await fetch(`${API_BASE_URL}/api/communication/history?page=${page}&size=${size}`, {
      headers: this.getAuthHeaders()
    });
    return res.json();
  }

  async getStats() {
    const res = await fetch(`${API_BASE_URL}/api/communication/stats`, {
      headers: this.getAuthHeaders()
    });
    return res.json();
  }

  async getGateway() {
    const res = await fetch(`${API_BASE_URL}/api/communication/gateway`, {
      headers: this.getAuthHeaders()
    });
    return res.json();
  }

  async saveGateway(settings) {
    const res = await fetch(`${API_BASE_URL}/api/communication/gateway`, {
      method: 'POST',
      headers: this.getAuthHeaders(),
      body: JSON.stringify(settings)
    });
    return res.json();
  }

  async testWhatsApp(testPhone, message = '') {
    const res = await fetch(`${API_BASE_URL}/api/attendance/test-whatsapp`, {
      method: 'POST',
      headers: this.getAuthHeaders(),
      body: JSON.stringify({ testPhone, message })
    });
    return res.json();
  }
}

export default new CommunicationHubService();
